module.exports = __webpack_public_path__ + "aba0d5d41ddf7489c61386a5725af254.gif";